<div class="container p-0">
  <div class="position-relative subsections-container">
    <div class="section-subsection-selection-container">
      <div class="progress line-h-unset d-flex flex-column flex-md-row flex-nowrap">
        @for (section of sections(); track section.key) {
          <button
            type="button"
            class="progress-bar"
            [class.inactive]="selectedSection() && selectedSectionKey() !== section.key"
            [class.selected]="selectedSectionKey() === section.key"
            [style.width]="'100%'"
            (click)="selectSection(section.key)">
            <span class="text-uppercase text-nowrap">{{ tr(section.label) }}</span>
          </button>
        }
      </div>

      @if (selectedSection()) {
        <div class="row m-0 py-2 px-4 sections-container d-flex align-items-center">
          <ul
            class="nav stages-created d-flex align-items-center mt-2 me-2 w-100"
            cdkDropList
            id="stages-created"
            [cdkDropListData]="subsections()"
            [cdkDropListOrientation]="'mixed'"
            (cdkDropListDropped)="onDrop($event)"
            [class.empty-box-drop]="!subsections().length">
            @for (subsection of subsections(); track subsection.directoryUuid || subsection.name) {
              <li
                class="nav-item subsection-button"
                cdkDrag
                [cdkDragData]="subsection"
                [cdkDragDisabled]="isLoading() || subsection.pending"
                style="background-color: #000; color: #fff">
                <div class="d-flex align-items-center h-100 v-100">
                  <div class="d-block flex-fill">
                    @if (subsection.pending) {
                      <div class="d-flex align-items-center h-100">
                        <mtm-loading-spinner [size]="32" />
                      </div>
                    } @else {
                      <div class="col p-0">
                        <p class="m-0 section-without-dates">
                          <span class="text-uppercase">{{ tr(subsection.name) }}</span>
                        </p>
                      </div>
                    }
                  </div>
                  @if (!subsection.pending) {
                    <div class="d-block ps-2">
                      <button
                        type="button"
                        class="btn-remove-subsection"
                        [attr.aria-label]="tr('project_stages_deleteSubsection')"
                        (click)="promptDelete(subsection); $event.stopPropagation()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  }
                </div>
              </li>
            }
            <li class="nav-item empty-box drop-here" style="min-width: 123px">
              <div class="nav-content d-flex align-items-center h-100 w-100">
                <p class="m-0">
                  <span class="text-uppercase _700">{{ tr('addHere') }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      }
    </div>

    <div class="d-block mt-4">
      <span class="text-info">{{ tr('projectTextInfo') }}</span>
    </div>

    @if (selectedSection()) {
      <div class="d-block drag-and-drop py-3 px-0">
        <ul
          class="nav w-100 stages-draggables d-flex flex-column flex-md-row flex-wrap"
          cdkDropList
          id="stages-draggables"
          [cdkDropListData]="draggables()"
          [cdkDropListConnectedTo]="['stages-created']"
          [cdkDropListOrientation]="'mixed'"
          cdkDropListSortingDisabled>
          @for (draggable of draggables(); track draggable.blueprintNodeUuid) {
            <li
              class="nav-item subsection-draggable"
              cdkDrag
              [cdkDragData]="draggable"
              [cdkDragDisabled]="isLoading() || isLoadingSubsections()"
              [style.background-color]="'#000'">
              <div class="nav-content d-flex align-items-center">
                <p class="m-0 w-100 text-center flex-fill text-nowrap">
                  <span class="text-uppercase font-weight-bold">{{ tr(draggable.blueprintNodeName) }}</span>
                </p>
              </div>
              <ng-template cdkDragPlaceholder>
                <li class="nav-item subsection-draggable subsection-draggable-placeholder"></li>
              </ng-template>
            </li>
          } @empty {
            <li class="nav-item drop-here text-uppercase">{{ tr('projectStages_noTemplatesAvailable') }}</li>
          }
        </ul>
      </div>
    }

    @if (isLoading()) {
      <div class="d-flex align-items-center justify-content-center loading-container">
        <mtm-loading-spinner [size]="32" />
      </div>
    }
  </div>
</div>
